import { render, staticRenderFns } from "./MDpost.vue?vue&type=template&id=6bd87174"
import script from "./MDpost.vue?vue&type=script&lang=js"
export * from "./MDpost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports